import { render, staticRenderFns } from "./AccrualsEstimationMethodSection.vue?vue&type=template&id=5ee9ad20&scoped=true"
import script from "./AccrualsEstimationMethodSection.vue?vue&type=script&lang=js"
export * from "./AccrualsEstimationMethodSection.vue?vue&type=script&lang=js"
import style0 from "./AccrualsEstimationMethodSection.vue?vue&type=style&index=0&id=5ee9ad20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee9ad20",
  null
  
)

export default component.exports